import React from 'react';

import { countCodePoints } from '@travel/utils';

import cx from '../../../utils/classNames';
import { defaultNumberFormatter } from '../../../utils/numberFormatter';
import toCamelCase from '../../../utils/toCamelCase';

import styles from '../textField.module.scss';

/** Custom props */
export type TextFieldCountProps = {
  /** Custom class to overwrite default styling if needed */
  className?: string;

  /* Function to count characters typed in the input*/
  handleTextFieldCharacterCount?: (str: string, locale?: string) => number;

  /** maximum character count of a field */
  maxLength?: number;

  /* Value of text field */
  value?: string;

  /** Custom class to overwrite default styling of max length exceeded case if needed */
  maxLengthExceedClassName?: string;

  /** Custom function to format the count display */
  countFormatter?: (value: number) => string;
};

export function Count(props: TextFieldCountProps) {
  const {
    className,
    maxLength,
    handleTextFieldCharacterCount = countCodePoints,
    value = '',
    maxLengthExceedClassName,
    countFormatter = defaultNumberFormatter,
  } = props;
  const classNames = cx(styles[toCamelCase('textField', 'textCount')], className);

  const charCount = handleTextFieldCharacterCount(value);
  const displayText = maxLength
    ? `${countFormatter(charCount)}/${countFormatter(maxLength)}`
    : countFormatter(charCount);

  return (
    <>
      <span
        key={value}
        className={cx(
          classNames,
          maxLength && charCount > maxLength
            ? cx(styles[toCamelCase('textField', 'maxLengthExceedError')], maxLengthExceedClassName)
            : '',
        )}
        data-testid="textField-textCount"
      >
        {displayText}
      </span>
    </>
  );
}

export default Count;
